var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { NgZone } from '@angular/core';
import { InfluencerGroup } from '../../../models/influencer-group';
import { GroupService } from '../../services/group-details/group.service';
import { CampaignInfluencerStatus, CommonConstant, RecentlyVisitedInfluencerGroup, InfluencerGroupStatus } from '../../app.constants';
import { Influencer } from '../../../models/influencer';
import { ActivatedRoute, Router } from '@angular/router';
import { ReferenceDataService } from '../../services/reference-data/reference-data.service';
import { GroupSearch } from '../../../models/group-search';
import { UserService } from '../../services/user.service';
import { ModalService } from '../../services/modal/modal.service';
import { AchooPopupComponent } from '../../core/achoo-popup/achoo-popup.component';
import { CampaignService } from '../../services/campaign/campaign.service';
import { InfluencerGroupsService } from '../influencer-groups/influencer-groups.service';
import { PlaceholderVisibilityService } from '../../services/placeholder-visibility/placeholder-visibility.service';
import { AbstractAchooComponent } from '../abstract-achoo.component';
import { Location as NgCommonLocation } from '@angular/common';
import { ActionDetails, ActionSource, ActivePages, EventTrackerService, Page, TargetType, UserActionType } from '../../services/event-tracker/event-tracker.service';
import { CacheService } from '../../services/cache/cache.service';
import { InfluencerService } from '../../services/influencer/influencer.service';
import { TranslateService } from '@ngx-translate/core';
import { ObjectUtils } from '../../utils/object.utils';
import * as Sentry from '@sentry/browser';
import { AppSettings } from '../../utils/app-settings';
import { WebUtils } from '../../utils/web.utils';
import { InvalidAction } from '../../../models/user';
import { GroupDetailsBreadcumbComponent } from './group-details-breadcumb/group-details-breadcumb.component';
import { BottombarInfluencerFragementComponent } from '../bottombar-influencer-fragement/bottombar-influencer-fragement.component';
import { NewInfluencerGroup } from '../../../models/auto-group/auto-group-setting';
var GroupDetailsComponent = /** @class */ (function (_super) {
    __extends(GroupDetailsComponent, _super);
    function GroupDetailsComponent(groupService, userService, route, router, referenceDataService, location, campaignService, influencerGroupService, modalService, cacheService, placeholderVisibilityService, ngZone, eventTracker, influencerService, translate) {
        var _this = _super.call(this, userService) || this;
        _this.groupService = groupService;
        _this.userService = userService;
        _this.route = route;
        _this.router = router;
        _this.referenceDataService = referenceDataService;
        _this.location = location;
        _this.campaignService = campaignService;
        _this.influencerGroupService = influencerGroupService;
        _this.modalService = modalService;
        _this.cacheService = cacheService;
        _this.placeholderVisibilityService = placeholderVisibilityService;
        _this.ngZone = ngZone;
        _this.eventTracker = eventTracker;
        _this.influencerService = influencerService;
        _this.translate = translate;
        _this.INTERNATIONAL_COUNTRY_ID = 250;
        _this.influencerGroup = new InfluencerGroup();
        _this.scrollDistance = CommonConstant.DEFAULT_INFINITE_SCROLL_DISTANCE;
        _this.scrollUpDistance = CommonConstant.DEFAULT_INFINITE_SCROLL_DISTANCE_UP;
        _this.throttle = CommonConstant.DEFAULT_INFINITE_SCROLL_THROTTLE;
        // Keep previous influencer group and used in case update failed.
        _this.previousInfluencerGroup = new InfluencerGroup();
        _this.influencerList = [];
        _this.deleteInfluencers = [];
        _this.countryList = [];
        _this.platformList = [];
        _this.totalInfluencer = 0;
        _this.currentPageIndex = CommonConstant.START_PAGE_INDEX;
        _this.pendingInfluencerList = [];
        _this.selectedInfluencers = [];
        // search criteria
        _this.searchCriteria = new GroupSearch();
        // state of search bar
        _this.openSearchBar = false;
        _this.isFetchingNextInfluencerResult = false;
        _this.isWaitingNextInfluencerResult = false;
        _this.isRecentlyVisitedInfluencerGroup = false;
        _this.isRequestReview = false;
        _this.showFetchMoreBtn = false;
        _this.isLoadingData = false;
        _this.referenceDataService.loadDefinitions().subscribe(function (res) {
            _this.countryList = res.data.countries;
            _this.platformList = res.data.platforms;
            _this.internationalCountry = _this.countryList.find(function (x) { return x.id === _this.INTERNATIONAL_COUNTRY_ID; });
        });
        _this.isActiveDiscoverFollower = AppSettings.isEnableDiscoverFollower();
        return _this;
    }
    GroupDetailsComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (this.influencerGroup && this.influencerGroup.status && this.influencerGroup.status === InfluencerGroupStatus.PENDING) {
            return;
        }
        this.route.data.subscribe(function (data) {
            _this.isRecentlyVisitedInfluencerGroup = data.isRecentlyVisitedInfluencerGroup ? data.isRecentlyVisitedInfluencerGroup : false;
        });
        _super.prototype.ngOnInit.call(this);
        if (!this.isRecentlyVisitedInfluencerGroup) {
            this.loadNormalInfluencerGroupData();
            this.fetchPendingInfluencerList(false);
        }
        else {
            this.loadRecentlyVisitedInfluencerGroupData();
        }
        if (this.cacheService.hasValidCachedValue("influencer_list_of_group_" + this.influencerGroupId)) {
            this.cacheService.get("influencer_list_of_group_" + this.influencerGroupId).subscribe(function (res) {
                _this.influencerList = res;
                var influencerIds = _this.influencerList.map(function (inf) { return inf.id; });
                _this.preloadInfluencerDetaisList(influencerIds, false);
            });
            this.cacheService.get("influencer_list_of_group_" + this.influencerGroupId + "_scrollId").subscribe(function (data) {
                _this.searchCriteria.scrollId = data;
            });
        }
        else {
            this.fetchInfluencerListOfGroup(CommonConstant.START_PAGE_INDEX);
        }
        this.isRequestReview = AppSettings.isRequestReview();
    };
    GroupDetailsComponent.prototype.onWindowScroll = function () {
        var _this = this;
        this.ngZone.runOutsideAngular(function () {
            if (document.documentElement.scrollTop > 0) {
                _this.cacheService.set("group_details_" + _this.influencerGroupId + "_scroll_top", document.documentElement.scrollTop);
            }
        });
    };
    GroupDetailsComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        _super.prototype.ngAfterViewInit.call(this);
        setTimeout(function () {
            if (_this.cacheService.has("group_details_" + _this.influencerGroupId + "_scroll_top")) {
                _this.cacheService.get("group_details_" + _this.influencerGroupId + "_scroll_top").subscribe(function (pos) {
                    window.scrollTo(0, pos);
                });
            }
        }, 100);
    };
    GroupDetailsComponent.prototype.loadNormalInfluencerGroupData = function () {
        var _this = this;
        this.route.params.subscribe(function (params) {
            _this.influencerGroupId = _this.influencerGroupId ? _this.influencerGroupId : +params['influencer_group_id'];
        });
        var groupKey = "influencer_group_" + this.influencerGroupId;
        this.initializeSearchCriteria();
        this.cacheService.get(groupKey, this.groupService.getInfluencerGroup(this.influencerGroupId)).subscribe(function (res) {
            _this.influencerGroupSetting = res;
            if (_this.influencerGroupSetting instanceof NewInfluencerGroup) {
                _this.influencerGroup.influencer_group_id = _this.influencerGroupSetting.id;
                _this.influencerGroup.influencer_group_name = _this.influencerGroupSetting.name;
                _this.influencerGroup.influencer_group_description = _this.influencerGroupSetting.description;
                _this.influencerGroup.influencer_group_type_id = _this.influencerGroupSetting.type;
            }
            else {
                _this.influencerGroup = _this.influencerGroupSetting;
            }
            _this.previousInfluencerGroup = ObjectUtils.deepClone(_this.influencerGroup);
            // no tracking if response is null
            if (!res) {
                return;
            }
            // segment track event view details group
            _this.eventTracker.trackUserAction(UserActionType.VIEW, Page.GROUP, {
                id: _this.influencerGroupId,
                name: res.influencer_group_name,
                type: Page.GROUP
            }, undefined, undefined, {
                type: ActivePages.GROUP_DETAILS,
                name: res.influencer_group_name,
                id: _this.influencerGroupId
            });
        });
        this.influencerService.cancelCurrentPreloadingRequest();
    };
    GroupDetailsComponent.prototype.loadRecentlyVisitedInfluencerGroupData = function () {
        this.influencerGroup.influencer_group_name = RecentlyVisitedInfluencerGroup.name;
        this.influencerGroup.influencer_group_description = RecentlyVisitedInfluencerGroup.description;
        // segment track event view recently visited influencer group
        this.eventTracker.trackUserAction(UserActionType.VIEW, Page.RECENTLY_VIEWED_INFLUENCERS_GROUP, undefined, undefined, undefined, undefined);
    };
    GroupDetailsComponent.prototype.initializeSearchCriteria = function () {
        var _this = this;
        this.route.queryParams.subscribe(function (params) {
            var formatedParams = {};
            Object.keys(params).forEach(function (key) {
                // should not take into account default param
                if (key !== 'activeAccount' && key !== 'searchString') {
                    _this.openSearchBar = true;
                }
                var rawValue = params[key];
                if (isNaN(rawValue)) {
                    formatedParams[key] = rawValue;
                }
                else {
                    formatedParams[key] = Number(rawValue);
                }
            });
            _this.searchCriteria = Object.assign({}, _this.searchCriteria, formatedParams);
        });
    };
    GroupDetailsComponent.prototype.companyChangeCallback = function (companyId) {
        var _this = this;
        this.campaignService.getCampaignShortListForCompany(companyId).subscribe(function (res) {
            _this.campaignList = res ? res.filter(function (campaignItem) { return campaignItem.status !== CampaignInfluencerStatus.ARCHIVED; }).map(function (campaign) { return ({
                id: campaign.id,
                name: campaign.name,
                brief: campaign.brief
            }); }) : [];
        });
        // load list influencer group
        this.influencerGroupService.getInfluencerGroupShortList(companyId).subscribe(function (res) {
            _this.influencerGroupList = res.map(function (group) { return ({
                id: group.id,
                name: group.name,
                description: group.description
            }); });
            if (!_this.isRecentlyVisitedInfluencerGroup && !_this.influencerGroupList.find(function (group) { return group.id === _this.influencerGroupId; })) {
                _this.router.navigate(['/groups']);
            }
        });
    };
    GroupDetailsComponent.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
        this.cancelPendingRequest();
        this.cacheService.clear(GroupDetailsComponent.INFLUENCER_DETAILS_LIST_KEY);
    };
    GroupDetailsComponent.prototype.beforeActiveBottomBar = function () {
        if (this.influencerGroup.status === InfluencerGroupStatus.PENDING) {
            return;
        }
        this.activeBottomBar = 'active';
    };
    GroupDetailsComponent.prototype.closeBottonBar = function (evt) {
        if (evt && evt.bulkUploadInfluencers) {
            // this is for optimistic ui when adding bulk influencers
            this.isLoadingData = true;
            var newAddedInfluencer = this.updateInfluencerGroupList(evt.bulkUploadInfluencers);
            this.influencerList = (_a = newAddedInfluencer.reverse()).concat.apply(_a, this.influencerList);
            this.totalInfluencer = this.influencerList.length;
        }
        if (evt && evt.isReloadInfluencerList) {
            this.reloadInfluencerList();
        }
        if (this.activeBottomBar === 'active') {
            this.activeBottomBar = 'inactive';
        }
        var _a;
    };
    GroupDetailsComponent.prototype.updateInfluencerGroupList = function (data) {
        var _this = this;
        return data.map(function (item) {
            var mappedInfluencerItem = new Influencer();
            mappedInfluencerItem.influencer_id = 0;
            mappedInfluencerItem.influencer_name = item.handle;
            mappedInfluencerItem.country = _this.countryList[103];
            mappedInfluencerItem.country_code = CommonConstant.INTERNATIONAL_COUNTRY_DATA.code;
            mappedInfluencerItem.country_name = CommonConstant.INTERNATIONAL_COUNTRY_DATA.name;
            mappedInfluencerItem.platform = item.platform;
            mappedInfluencerItem.isNewAdded = true;
            mappedInfluencerItem.isPending = false;
            return mappedInfluencerItem;
        });
    };
    GroupDetailsComponent.prototype.deleteInfluencerFromBottomBar = function (evt) {
        this.deleteInfluencers = evt.influencerToDelete;
        this.deleteSelectedInfluencers();
    };
    GroupDetailsComponent.prototype.deleteSelectedInfluencers = function () {
        var selectedInfluencerToDeleteIds = this.deleteInfluencers.map(function (influencer) { return influencer.influencer_id; });
        this.deleteMultipleInfluencers(selectedInfluencerToDeleteIds);
        this.closeWarningDeleteInfluencerPopup();
    };
    GroupDetailsComponent.prototype.showWarningDeleteInfluencerPopup = function (influencers) {
        this.deleteInfluencers = influencers;
        this.modalService.openInCenter(this.warningDeleteInfluencerDialog);
    };
    GroupDetailsComponent.prototype.onRejectSuggestedInfluencer = function (influencer) {
        var _this = this;
        // optimistic UI, add influencer immediately
        this.updateInfluencerList(influencer, true);
        // call API to delete server side
        this.groupService.deleteInfluencerOfGroup([influencer.id], this.influencerGroupId, this.companyId)
            .subscribe(function (res) {
            // do nothing
        }, function (error) {
            // revert previous list when error occurred
            _this.pendingInfluencerList = _this.previousPendingInfluencerList;
            // show error message
            _this.serverErrorMessage = _this.translate.instant('group_details.influencer.delete_influencer_error');
            _this.modalService.open(_this.serverErrorNotification, _this.beforeClearErrorNotif.bind(_this), true);
        });
    };
    GroupDetailsComponent.prototype.approveNewInfluencer = function (influencer) {
        var _this = this;
        // optimistic UI, add influencer immediately
        this.updateInfluencerList(influencer);
        // call API to update server side
        this.groupService.approveInfluencerInGroup([influencer.id], this.influencerGroupId, this.companyId).subscribe(function (res) {
            _this.sendMixpanelWhenApproveInfluencer(influencer, null);
            _this.eventTracker.trackUserAction(UserActionType.CHAM_ADD_INFLUENCER_TO_GROUP);
        }, function (error) {
            // revert previous list when error occurred
            _this.pendingInfluencerList = _this.previousPendingInfluencerList;
            _this.influencerList = _this.previousInfluencerList;
            _this.totalInfluencer = _this.totalInfluencer - 1;
            _this.hanldeUnexpectedError();
        });
    };
    GroupDetailsComponent.prototype.updateInfluencerList = function (influencer, isRemoved) {
        if (isRemoved === void 0) { isRemoved = false; }
        // keep the current list to revert when API fails
        this.previousPendingInfluencerList = ObjectUtils.deepClone(this.pendingInfluencerList);
        this.previousInfluencerList = ObjectUtils.deepClone(this.influencerList);
        if (isRemoved) {
            this.pendingInfluencerList = this.pendingInfluencerList.filter(function (infl) { return infl.id !== influencer.id; });
        }
        else {
            var approvedInfluencer = this.pendingInfluencerList.find(function (infl) { return infl.id === influencer.id; });
            approvedInfluencer.isPending = false;
            this.influencerList.unshift(approvedInfluencer);
            this.totalInfluencer += 1;
            this.pendingInfluencerList = this.pendingInfluencerList.filter(function (inf) { return inf.id !== influencer.id; });
        }
    };
    GroupDetailsComponent.prototype.searchInfluencerByText = function (str) {
        if (str && str !== '') {
            this.searchCriteria.searchString = str;
        }
        else {
            this.searchCriteria.searchString = undefined;
        }
        this.advanceSearchInfluencerList(new GroupSearch());
    };
    GroupDetailsComponent.prototype.advanceSearchInfluencerList = function (groupSearch) {
        this.searchCriteria = Object.assign({}, this.searchCriteria, groupSearch);
        this.searchCriteria.scrollId = undefined;
        this.updateSearchCriteriaOnLink(this.searchCriteria);
        this.fetchInfluencerListOfGroup(CommonConstant.START_PAGE_INDEX, false);
    };
    GroupDetailsComponent.prototype.selectAllInfluencer = function (e) {
        if (e) {
            this.influencerList.filter(function (infl) { return !infl.isPending; }).forEach(function (influencer) {
                influencer.selected = true;
            });
            this.trackSelectingInfluencerEvent();
            this.showNotificationSelectAll();
        }
        else {
            this.influencerList.filter(function (infl) { return !infl.isPending; }).forEach(function (influencer) {
                influencer.selected = false;
            });
            this.closeNotificationSelectAll();
        }
    };
    GroupDetailsComponent.prototype.onSelectSingleInfluencer = function (selectedInfluencer) {
        var _this = this;
        this.influencerList.forEach(function (influencer) {
            if (influencer.influencer_id === selectedInfluencer.influencer_id) {
                influencer.selected = !influencer.selected;
                if (influencer.selected) {
                    _this.selectedInfluencers.push(influencer);
                }
            }
        });
        if (selectedInfluencer.selected === true) {
            this.trackSelectingInfluencerEvent(selectedInfluencer);
        }
    };
    GroupDetailsComponent.prototype.trackSelectingInfluencerEvent = function (selectedInfluencer) {
        // track event to Segment
        this.eventTracker.trackUserAction(UserActionType.ACTION, Page.GROUP, {
            id: selectedInfluencer && selectedInfluencer.influencer_id || '*',
            name: selectedInfluencer && selectedInfluencer.influencer_name || 'all',
            type: TargetType.INFLUENCER
        }, {
            action: UserActionType.SELECTION,
            source: ActionSource.PAGE
        }, undefined, {
            type: ActivePages.GROUP_DETAILS,
        });
    };
    GroupDetailsComponent.prototype.closeWarningDeleteInfluencerPopup = function () {
        this.deleteInfluencers = [];
        this.modalService.close();
    };
    GroupDetailsComponent.prototype.onScrollDown = function () {
        if (this.isFetchingNextInfluencerResult && !this.isRecentlyVisitedInfluencerGroup) {
            this.isWaitingNextInfluencerResult = true;
        }
        else {
            this.currentPageIndex++;
            this.fetchInfluencerListOfGroup(this.currentPageIndex, true);
        }
    };
    GroupDetailsComponent.prototype.reloadInfluencerList = function (isLoadMore) {
        if (isLoadMore === void 0) { isLoadMore = false; }
        this.searchCriteria.scrollId = undefined;
        this.fetchInfluencerListOfGroup(CommonConstant.START_PAGE_INDEX, isLoadMore);
    };
    Object.defineProperty(GroupDetailsComponent.prototype, "numberInfluencerToDelete", {
        get: function () {
            return this.deleteInfluencers.length;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GroupDetailsComponent.prototype, "previewInfluencerList", {
        get: function () {
            var activeInfluencerIds = this.influencerList.map(function (infl) { return infl.id; });
            var hiddenSelectedInfluencers = this.selectedInfluencers.filter(function (si) { return activeInfluencerIds.indexOf(si.id) < 0; });
            return (_a = this.influencerList).concat.apply(_a, hiddenSelectedInfluencers);
            var _a;
        },
        enumerable: true,
        configurable: true
    });
    GroupDetailsComponent.prototype.loadInfluencerListOfGroup = function (groupSearch, isLoadMore) {
        // remove undefined request param
        Object.keys(groupSearch).forEach(function (key) {
            if (groupSearch[key] === undefined) {
                delete groupSearch[key];
            }
        });
        this.placeholderVisibilityService.show(CommonConstant.GROUP_DETAILS_PLACEHOLDER);
        if (!this.isRecentlyVisitedInfluencerGroup) {
            this.getInfluencerListByGroupId(groupSearch, isLoadMore);
        }
        else {
            this.getMonthlyVisitInfluencer(groupSearch.limit, isLoadMore);
        }
    };
    GroupDetailsComponent.prototype.getInfluencerListByGroupId = function (groupSearch, isLoadMore) {
        var _this = this;
        // stop loading if group id is undefined
        if (!this.influencerGroupId) {
            return;
        }
        var groupId = this.influencerGroupId.toString();
        this.groupSubscription = this.groupService.getInfluencerListByGroupId(groupSearch, groupId).subscribe(function (res) {
            _this.isFetchingNextInfluencerResult = false;
            if (!res.data || !res.data.influencers) {
                _this.placeholderVisibilityService.hide(CommonConstant.GROUP_DETAILS_PLACEHOLDER);
                return;
            }
            var addedInfluencerList = _this.mapInfluencerData(res.data.influencers);
            var selectedInfluencerIds = _this.selectedInfluencers.map(function (si) { return si.id; });
            addedInfluencerList.forEach(function (infl) { return infl.selected = selectedInfluencerIds.indexOf(infl.id) >= 0; });
            var influencerList = addedInfluencerList;
            // update lasted sort value for pagination
            _this.updateScrollId(res.data.scrollId);
            _this.cacheService.set("influencer_list_of_group_" + _this.influencerGroupId + "_scrollId", res.data.scrollId);
            _this.reloadInfluencerData(influencerList, isLoadMore);
            _this.cacheService.set("influencer_list_of_group_" + _this.influencerGroupId, _this.influencerList);
            // preload influencer details data
            var influencerIds = influencerList.map(function (inf) { return inf.id; });
            _this.preloadInfluencerDetaisList(influencerIds, isLoadMore);
            _this.totalInfluencer = isLoadMore ? _this.totalInfluencer : res.data.totalInfluencers;
            _this.placeholderVisibilityService.hide(CommonConstant.GROUP_DETAILS_PLACEHOLDER);
        });
    };
    GroupDetailsComponent.prototype.getMonthlyVisitInfluencer = function (limit, isLoadMore) {
        var _this = this;
        if (this.influencerList && this.influencerList.length === 0) {
            this.offsetId = 0;
        }
        else {
            this.offsetId = this.influencerList[this.influencerList.length - 1].offsetId;
        }
        this.groupService.getMonthlyVisitInfluencer(this.companyId, limit, this.offsetId).subscribe(function (res) {
            if (!res || !res.influencers) {
                _this.placeholderVisibilityService.hide(CommonConstant.GROUP_DETAILS_PLACEHOLDER);
                return;
            }
            var influencerList = _this.mapInfluencerData(res.influencers);
            _this.reloadInfluencerData(influencerList, isLoadMore);
            _this.totalInfluencer = res.total;
            _this.placeholderVisibilityService.hide(CommonConstant.GROUP_DETAILS_PLACEHOLDER);
        }, function (error) {
            Sentry.captureException(new Error('Failed to load Recently Viewed influencers'));
            _this.modalService.openInCenter(_this.alertInfluencerApiFail, undefined);
        });
    };
    GroupDetailsComponent.prototype.reloadInfluencerData = function (influencerList, isLoadMore) {
        var _this = this;
        if (this.isWaitingNextInfluencerResult) {
            (_a = this.influencerList).push.apply(_a, influencerList);
            this.isWaitingNextInfluencerResult = false;
            // start fetching the next pending result
            this.currentPageIndex += 1;
            this.fetchInfluencerListOfGroup(this.currentPageIndex, true);
        }
        else if (isLoadMore) {
            if (!this.isRecentlyVisitedInfluencerGroup) {
                (_b = this.influencerList).push.apply(_b, influencerList);
            }
            else {
                this.influencerList = this.influencerList.concat(influencerList.filter(function (listItem) { return _this.influencerList.every(function (item) { return item.id !== listItem.id; }); }));
            }
        }
        else if (this.isLoadingData) {
            this.influencerList = this.updateNewAddedInfluencerItem(influencerList);
            this.isLoadingData = false;
        }
        else {
            this.influencerList = influencerList;
        }
        var _a, _b;
    };
    GroupDetailsComponent.prototype.updateNewAddedInfluencerItem = function (influencerList) {
        var _this = this;
        var result = [];
        var addedInfluencerIds = new Set();
        this.influencerList.forEach(function (item) {
            if (item.influencer_id === 0) {
                var newAddedItem = influencerList.find(function (influencerListItem) { return influencerListItem.influencer_name === item.influencer_name; });
                if (newAddedItem) {
                    _this.pushInfluencerToArrayIfNotExist(result, addedInfluencerIds, newAddedItem);
                }
                return;
            }
            _this.pushInfluencerToArrayIfNotExist(result, addedInfluencerIds, item);
        });
        // Traverse added influencer list from API one more time because we still have the case that influencer name change after uploaded
        influencerList.forEach(function (newAddedItem) { return _this.pushInfluencerToArrayIfNotExist(result, addedInfluencerIds, newAddedItem); });
        return result;
    };
    GroupDetailsComponent.prototype.pushInfluencerToArrayIfNotExist = function (desArray, cacheIds, influencer) {
        if (cacheIds.has(influencer.influencer_id)) {
            return;
        }
        desArray.push(influencer);
        cacheIds.add(influencer.influencer_id);
    };
    GroupDetailsComponent.prototype.mapInfluencerData = function (rawInfluencerList, isPendingList) {
        var _this = this;
        if (!rawInfluencerList) {
            return [];
        }
        return rawInfluencerList.map(function (inf) {
            _this.setDefaultCountry(inf);
            return {
                isPending: isPendingList ? true : false,
                id: inf.influencerId,
                influencer_group_id: inf.groupId,
                company_id: inf.companyId,
                influencer_id: inf.influencerId,
                influencer_name: inf.influencerName,
                influencer_image: inf.profilePicture,
                country: inf.country ? inf.country.name : null,
                country_code: inf.country ? inf.country.code : null,
                language: {
                    name: inf.language ? inf.language.name : null,
                    code: inf.language ? inf.language.code : null,
                    id: inf.language ? inf.language.id : null,
                },
                platform: inf.platforms,
                reach: inf.reach,
                engagement: inf.engagement,
                impression: inf.impression,
                impact: inf.impact,
                numberOfPosts: inf.numberOfPosts,
                numberOfFollowers: inf.numberOfFollowers,
                topMention: inf.topMentions,
                channels: inf.channels,
                favoriteTopics: inf.favouriteTopics ? inf.favouriteTopics.join(', ') : null,
                offsetId: inf.id
            };
        });
    };
    GroupDetailsComponent.prototype.fetchInfluencerListOfGroup = function (currentPageIndex, isLoadMore) {
        if (isLoadMore === void 0) { isLoadMore = false; }
        this.isFetchingNextInfluencerResult = true;
        // cancel previous request
        this.cancelPendingRequest();
        // calculation offset
        this.searchCriteria.limit = CommonConstant.PAGINATION_INFLUENCER_SIZE;
        this.searchCriteria.offset = (currentPageIndex - 1) * CommonConstant.PAGINATION_INFLUENCER_SIZE;
        // perform search
        this.loadInfluencerListOfGroup(this.searchCriteria, isLoadMore);
        if (!this.isRecentlyVisitedInfluencerGroup) {
            this.fetchPendingInfluencerList(isLoadMore);
        }
    };
    GroupDetailsComponent.prototype.deleteMultipleInfluencers = function (influencerToDeleteIds) {
        var _this = this;
        var currentCompanyId = this.userService.getCompanyId();
        // keep removed indexs and remove influencer on UI immediately
        var deletedInfluencerIndexMap = new Map();
        this.deleteInfluencers.forEach(function (di) {
            var removingIndex = _this.influencerList.findIndex(function (inf) { return inf.id === di.id; });
            deletedInfluencerIndexMap.set(di.id, removingIndex);
            _this.influencerList.splice(removingIndex, 1);
        });
        this.groupService.deleteInfluencerOfGroup(influencerToDeleteIds, this.influencerGroupId, currentCompanyId)
            .subscribe(function (res) {
            _this.modalService.close();
            var deleteInfluencers = _this.deleteInfluencers.map(function (influencer) { return ({
                id: influencer.influencer_id,
                name: influencer.influencer_name,
            }); });
            _this.deleteInfluencers = [];
            _this.totalInfluencer = _this.totalInfluencer - influencerToDeleteIds.length;
            _this.reloadInfluencerList();
            // track event to Segment
            _this.eventTracker.trackUserAction(UserActionType.ACTION, Page.GROUP, {
                id: _this.influencerGroup.influencer_group_id,
                name: _this.influencerGroup.influencer_group_name,
                type: TargetType.INFLUENCER_GROUP
            }, {
                action: UserActionType.UPDATE,
                actionDetails: ActionDetails.REMOVED_INFLUENCERS,
                source: ActionSource.PAGE,
                influencers: deleteInfluencers
            }, undefined, {
                type: ActivePages.GROUP_DETAILS,
                id: _this.influencerGroup.influencer_group_id,
                name: _this.influencerGroup.influencer_group_name
            });
        }, function (error) {
            // handle error, revert deleted influencer in correct position
            _this.deleteInfluencers.forEach(function (di) {
                _this.influencerList.splice(deletedInfluencerIndexMap.get(di.id), 0, di);
            });
            // show error message
            _this.serverErrorMessage = _this.translate.instant('group_details.influencer.delete_influencer_error');
            _this.modalService.open(_this.serverErrorNotification, _this.beforeClearErrorNotif.bind(_this), true);
        });
    };
    GroupDetailsComponent.prototype.beforeClearErrorNotif = function () {
        this.serverErrorMessage = null;
    };
    GroupDetailsComponent.prototype.cancelPendingRequest = function () {
        if (this.groupSubscription) {
            this.groupSubscription.unsubscribe();
        }
        this.placeholderVisibilityService.hideImmediately(CommonConstant.GROUP_DETAILS_PLACEHOLDER);
    };
    /**
     * Update pagination values
     */
    GroupDetailsComponent.prototype.updateScrollId = function (scrollId) {
        this.searchCriteria.scrollId = undefined;
        if (scrollId) {
            this.searchCriteria.scrollId = scrollId;
        }
    };
    GroupDetailsComponent.prototype.updateSearchCriteriaOnLink = function (criteria) {
        var cloneCriteria = new GroupSearch();
        cloneCriteria.selectedCountry = criteria.selectedCountry;
        cloneCriteria.selectedGender = criteria.selectedGender;
        cloneCriteria.selectedPlatform = criteria.selectedPlatform;
        if (criteria.reachFrom && criteria.reachFrom > 0) {
            cloneCriteria.reachFrom = criteria.reachFrom;
        }
        if (criteria.reachFrom && criteria.reachFrom > 0) {
            cloneCriteria.reachFrom = criteria.reachFrom;
        }
        if (criteria.reachTo && criteria.reachTo !== 1000000) {
            cloneCriteria.reachTo = criteria.reachTo;
        }
        if (criteria.engagementFrom && criteria.engagementFrom > 0) {
            cloneCriteria.engagementFrom = criteria.engagementFrom;
        }
        if (criteria.engagementTo && criteria.engagementTo !== 1000000) {
            cloneCriteria.engagementTo = criteria.engagementTo;
        }
        if (criteria.impactFrom && criteria.impactFrom > 0) {
            cloneCriteria.impactFrom = criteria.impactFrom;
        }
        if (criteria.impactTo && criteria.impactTo < 100) {
            cloneCriteria.impactTo = criteria.impactTo;
        }
        if (criteria.searchString && criteria.searchString !== '') {
            cloneCriteria.searchString = criteria.searchString;
        }
        var queries = Object.assign({}, cloneCriteria, {
            activeAccount: this.userService.getCompanyId()
        });
        var url = this.router
            .createUrlTree(["/groups/" + this.influencerGroupId], { queryParams: queries })
            .toString();
        this.location.replaceState(url.toString());
    };
    GroupDetailsComponent.prototype.preloadInfluencerDetaisList = function (influencerIds, isLoadMore) {
        this.influencerService.preloadInfluencerDataByIdList(influencerIds, null, isLoadMore);
    };
    // Fallback to "International" if country is nil
    GroupDetailsComponent.prototype.setDefaultCountry = function (inf) {
        if (!inf.country) {
            inf.country = this.internationalCountry;
        }
    };
    GroupDetailsComponent.prototype.backToPreviousPage = function () {
        this.location.back();
    };
    GroupDetailsComponent.prototype.closeErrorMsgModal = function () {
        this.modalService.close();
    };
    GroupDetailsComponent.prototype.fetchPendingInfluencerList = function (isLoadMore) {
        if (isLoadMore === void 0) { isLoadMore = true; }
        this.getPendingInfluencerList(isLoadMore);
    };
    GroupDetailsComponent.prototype.getPendingInfluencerList = function (isLoadMore, limit) {
        var _this = this;
        if (limit === void 0) { limit = 20; }
        // stop processing if group id is undefined
        if (!this.influencerGroupId) {
            return;
        }
        var lastSeenId;
        if (!isLoadMore || (this.pendingInfluencerList && this.pendingInfluencerList.length === 0)) {
            lastSeenId = 0;
        }
        else {
            lastSeenId = this.pendingInfluencerList[this.pendingInfluencerList.length - 1].offsetId;
        }
        this.groupService.getPendingInfluencerList(this.influencerGroupId, limit, lastSeenId).subscribe(function (res) {
            var pendingList = _this.mapInfluencerData(res.influencers, true);
            if (isLoadMore) {
                _this.pendingInfluencerList = _this.pendingInfluencerList.concat(pendingList.filter(function (listItem) { return _this.pendingInfluencerList.every(function (item) { return item.id !== listItem.id; }); }));
            }
            else {
                _this.pendingInfluencerList = pendingList;
            }
            _this.showFetchMoreBtn = _this.pendingInfluencerList.length < res.total && !_this.isRecentlyVisitedInfluencerGroup ? true : false;
        }, function (error) {
            WebUtils.reportErrorToSentry('Failed to load Pending Influencers List', error);
            _this.modalService.openInCenter(_this.alertInfluencerApiFail, undefined);
        });
    };
    Object.defineProperty(GroupDetailsComponent.prototype, "showEmptyResultMessage", {
        get: function () {
            return this.influencerList.length === 0 && this.pendingInfluencerList.length === 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GroupDetailsComponent.prototype, "numberOfSelectedInfluencers", {
        get: function () {
            if (!Array.isArray(this.influencerList)) {
                return 0;
            }
            return this.influencerList.filter(function (inf) { return inf.selected; }).length;
        },
        enumerable: true,
        configurable: true
    });
    GroupDetailsComponent.prototype.hanldeUnexpectedError = function () {
        this.serverErrorMessage = this.translate.instant('group_details.influencer.approve_influencer_error');
        this.modalService.open(this.serverErrorNotification, null, true);
    };
    GroupDetailsComponent.prototype.sendMixpanelWhenApproveInfluencer = function (influencer, limitInfo) {
        if (!limitInfo) {
            this.eventTracker.trackUserAction(UserActionType.ACTION, Page.GROUP, {
                id: this.influencerGroup.influencer_group_id,
                name: this.influencerGroup.influencer_group_name,
                type: TargetType.INFLUENCER_GROUP
            }, {
                action: UserActionType.UPDATE,
                actionDetails: ActionDetails.ADDED_INFLUENCERS,
                source: ActionSource.PENDING_LIST,
                influencer: influencer
            }, undefined, null);
        }
        else {
            var detailAction = new InvalidAction(true, limitInfo.blockedReason, limitInfo.wallType, limitInfo.wallName, true, limitInfo.maxValue, limitInfo.desiredValue, this.userService.accountLevelName);
            this.eventTracker.trackUserInvalidAction(detailAction, UserActionType.ACTION, Page.GROUP, {
                id: this.influencerGroup.influencer_group_id,
                name: this.influencerGroup.influencer_group_name,
                type: TargetType.INFLUENCER_GROUP
            }, {
                action: UserActionType.UPDATE,
                actionDetails: ActionDetails.ADDED_INFLUENCERS,
                source: ActionSource.PENDING_LIST,
                influencer: influencer
            }, undefined, null);
        }
    };
    GroupDetailsComponent.prototype.beforeAddingPendingInfluencerToGroup = function (evt) {
        if (!evt || (evt && evt.length === 0)) {
            return;
        }
        this.previousPendingInfluencerList = ObjectUtils.deepClone(this.pendingInfluencerList);
        var newAddedPendingInfluencer = this.mapInfluencerData(evt, true);
        this.pendingInfluencerList = this.pendingInfluencerList.concat(newAddedPendingInfluencer);
    };
    GroupDetailsComponent.prototype.addPendingInfluencerToGroupError = function () {
        this.pendingInfluencerList = this.previousPendingInfluencerList;
    };
    Object.defineProperty(GroupDetailsComponent.prototype, "activePage", {
        get: function () {
            return {
                type: ActivePages.GROUP_DETAILS
            };
        },
        enumerable: true,
        configurable: true
    });
    GroupDetailsComponent.prototype.updateGroupEvent = function (evt) {
        var influencerGroup = new InfluencerGroup();
        influencerGroup.influencer_group_id = evt.influencer_group_id;
        influencerGroup.influencer_group_name = evt.influencer_group_name;
        influencerGroup.influencer_group_description = evt.influencer_group_description;
        influencerGroup.influencer_group_type = evt.influencer_group_type_id;
        this.bottombarInfluencerFragement.influencerGroup = influencerGroup;
        this.bottombarInfluencerFragement.showCreateNewGroupFragment = true;
        this.bottombarInfluencerFragement.temporaryHidden = false;
        this.beforeActiveBottomBar();
    };
    GroupDetailsComponent.prototype.beforeUpdateGroupEvent = function (evt) {
        if (!evt || !evt.influencerGroupId || evt.influencerGroupId !== this.influencerGroup.influencer_group_id) {
            return;
        }
        this.influencerGroup.influencer_group_name = evt.influencerGroupName;
        this.influencerGroup.influencer_group_description = evt.influencerGroupDescription;
        this.groupDetailsBreadcumb.elementPaths[this.groupDetailsBreadcumb.elementPaths.length - 1].name = evt.influencerGroupName;
        this.bottombarInfluencerFragement.temporaryHidden = true;
        this.closeBottonBar();
    };
    GroupDetailsComponent.prototype.afterUpdateGroupEvent = function (evt) {
        if (!evt.isError) {
            this.bottombarInfluencerFragement.showCreateNewGroupFragment = false;
            this.sendUpdateGroupNameEvent(evt.data);
            if (this.influencerGroupSetting instanceof NewInfluencerGroup) {
                this.influencerGroupSetting.name = evt.data.influencerGroupName;
            }
            else {
                this.influencerGroupSetting.influencer_group_name = evt.data.influencerGroupName;
            }
        }
        else {
            this.handleUpdateGroupError();
        }
    };
    GroupDetailsComponent.prototype.sendUpdateGroupNameEvent = function (influencerGroupData) {
        this.eventTracker.trackUserAction(UserActionType.ACTION, Page.INFLUENCER_GROUP, {
            id: influencerGroupData.influencerGroupId,
            name: influencerGroupData.influencerGroupName,
            type: Page.INFLUENCER_GROUP
        }, __assign({ actionDetails: ActionDetails.UPDATED_DETAILS, source: ActionSource.ACTION_VIEW, action: UserActionType.UPDATE }, influencerGroupData), undefined, null, null);
    };
    GroupDetailsComponent.prototype.handleUpdateGroupError = function () {
        // Revert data
        this.influencerGroup = ObjectUtils.deepClone(this.previousInfluencerGroup);
        this.groupDetailsBreadcumb.elementPaths[this.groupDetailsBreadcumb.elementPaths.length - 1].name = this.previousInfluencerGroup.influencer_group_name;
        this.bottombarInfluencerFragement.influencerGroup.influencer_group_name = this.influencerGroup.influencer_group_name;
        this.bottombarInfluencerFragement.influencerGroup.influencer_group_description = this.influencerGroup.influencer_group_description;
        // Display bottom bar
        this.beforeActiveBottomBar();
        this.bottombarInfluencerFragement.temporaryHidden = false;
        this.bottombarInfluencerFragement.showCreateNewGroupFragment = true;
        this.modalService.open(this.updateInfluencerGroupError, null, true);
    };
    GroupDetailsComponent.prototype.editOrCreateProject = function (project) {
        this.beforeActiveBottomBar();
        this.bottombarInfluencerFragement.showCreateProjectFragement(project, false);
    };
    GroupDetailsComponent.prototype.showHideGroupSettings = function () {
        if (!this.groupDetailsBreadcumb) {
            return;
        }
        if (this.groupDetailsBreadcumb.showGroupSetting) {
            this.groupDetailsBreadcumb.closeSetting();
        }
        else {
            this.groupDetailsBreadcumb.editInfluencerGroupSetting();
        }
    };
    GroupDetailsComponent.prototype.clearSelectedInfluencers = function () {
        this.selectedInfluencers = [];
    };
    GroupDetailsComponent.prototype.showNotificationSelectAll = function () {
        this.selectAllInfluencerModalRef = this.modalService.open(this.selectAllInfluencers, null, true);
    };
    GroupDetailsComponent.prototype.closeNotificationSelectAll = function () {
        if (this.selectAllInfluencerModalRef) {
            this.modalService.closeSinglePopup(this.selectAllInfluencerModalRef);
        }
    };
    GroupDetailsComponent.INFLUENCER_DETAILS_LIST_KEY = 'influencer_details_list';
    return GroupDetailsComponent;
}(AbstractAchooComponent));
export { GroupDetailsComponent };



// WEBPACK FOOTER //
// ./src/app/main/group-details/group-details.component.ts.pre-build-optimizer.js